<template>
  <!-- 额度 -->
  <div>
    <div class="loan_card">
      <div class="low">
        <div class="tfv">
          <img class="kfd" src="/static/img/Container2.png" alt="" />
          <div :class="bgindex == 1 ? 'loan_card-label' : 'loan_card-labelbg'">ДОСТУПНАЯ СУММА КРЕДИТА</div>
        </div>
        <div class="tfv">
          <div class="nmk"></div>
          <div :class="bgindex == 1 ? 'xas' : 'xasbg'">В СЕТИ</div>
        </div>
      </div>
      <div :class="bgindex == 1 ? 'vfd' : 'vfdbg'">Сумма займа</div>
      <div class="loan_amount-row">
        <img class="nli" src="/static/img/Button.png" @click="getreduce" alt="" />
        <div class="oik">{{ unitConverter(displayRepayAmount) }} ₸</div>
        <img class="nli" src="/static/img/Button1.png" @click="getadd" alt="" />
      </div>
      <div class="loan_total">
        <span :class="bgindex == 1 ? 'ode' : 'odebg'">Вы берете:</span>
        <span :class="bgindex == 1 ? 'nkl' : 'nklbg'">{{ unitConverter(displayRepayAmount) }} ₸</span>
      </div>
      <div class="loi">
        <span :class="bgindex == 1 ? 'ode' : 'odebg'">К ВОЗВРАТУ:</span>
        <span :class="bgindex == 1 ? 'nkl' : 'nklbg'">{{ unitConverter(Interest) }} ₸</span>
      </div>
      <div class="loan_button"  @click="getlogin">
        <img class="nia" src="/static/img/Container1.png" alt="" />
        <div class="cfq">Получить деньги</div>
      </div>
      <div class="loan_note">*В зависимости от срока и суммы микрокредита</div>
    </div>
    <!-- <div class="support_panel" v-if="bgindex == 2">
      <div class="support_title">Нужна помощь?</div>
      <div class="support_text">Свяжитесь с нашей службой поддержки.</div>
      <div class="njc">
        <img class="koz" src="/static/img/Container6.png" alt="" />
        <div class="support_phone">+7 771 181 23 95</div>
      </div>
      <img class="support_image" src="/static/img/Maskgroup.png" alt="Поддержка" />
    </div> -->
  </div>
</template>

<script>
  import {
    userStepData
  } from '@/api/info'
  export default {
    name: 'LoanCard',
    props: {
      initialAmount: {
        type: Number,
        default: 165000,
      },
      minAmount: {
        type: Number,
        default: 10000,
      },
      maxAmount: {
        type: Number,
        default: 185000,
      },
      repayAmount: {
        type: Number,
        default: null,
      },
      bgindex: {
        type: Number,
        default: null,
      }
    },
    data() {
      return {
        loannum: this.initialAmount,
        Interest: 0,
        flage: false
      };
    },
    created() {
      if(this.loannum != 0) {
        this.Interest = this.loannum * 1.0001
      }
    },
    computed: {
      displayRepayAmount() {
        return this.repayAmount || this.loannum
      }
    },
    methods: {
      getadd() {
        console.log(11);
        if (this.loannum == this.maxAmount) return
        this.loannum += 5000
        this.Interest = this.loannum * 1.0001
      },
      getreduce() {
        if (this.loannum >= 5000 && this.loannum != this.minAmount) {
          this.loannum -= 5000
          this.Interest = this.loannum * 1.0001
        }
      },
      unitConverter(e) {
        if (!e) return 0
        const intPart = Math.trunc(e)
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        let floatPart = ''
        const valueArray = e.toString().split('.')
        if (valueArray.length === 2) {
          floatPart = valueArray[1].toString()
          return intPartFormat + '.' + floatPart
        }
        return intPartFormat + floatPart
      },
      getlogin() {
        if(this.flage) return
        this.flage = true
        userStepData().then(res => {
          if(localStorage.getItem('token')){
            if(res.data.statusCode != 0){
              this.flage = false
              if(res.data.statusCode == 301){
                this.$router.push('/login')
              }
            }else{
              this.flage = false
              var step = res.data.payload.step
              if(step == 100){
                this.$router.push('/underreview')
              }else if(step == 12){
                this.$router.push('/underreview')
              }else{
                this.$router.push('/login')
              }
            }
          }else{
            this.flage = false
            this.$router.push('/login')
          }
        })
      }
    },
  }
</script>

<style scoped>
  .loan_card{
    width: 2.78rem;
    border-radius: 0.21rem;
    background: rgba(255,255,255,0.7);
    box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(0,0,0,0.12);
    padding: 0.13rem;
    backdrop-filter: blur(0.08rem);
    z-index: 9999;
  }
  .low{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.17rem;
  }
  .tfv{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .kfd{
    width: 0.09rem;
    height: 0.09rem;
    margin-right: 0.04rem;
  }
  .loan_card-label{
    color: rgba(51, 51, 51, 1);
    font-family: Inter, Inter;
    font-size: 0.06rem;
    font-weight: bold;
  }
  .loan_card-labelbg{
    color: #5B403B;
    font-family: Inter, Inter;
    font-size: 0.06rem;
    font-weight: bold;
  }
  .nmk{
    width: 0.04rem;
    height: 0.04rem;
    background: #22C55E;
    border-radius: 52.08rem 52.08rem 52.08rem 52.08rem;
    margin-right: 0.02rem;
  }
  .xas{
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.05rem;
    color: #333333;
  }
  .xasbg{
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.05rem;
    color: #5B403B;
  }
  .vfd{
    text-align: center;
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.07rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .vfdbg{
    text-align: center;
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.07rem;
    color: #5B403B;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .loan_amount-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.23rem;
  }
  .nli{
    width: 0.26rem;
    height: 0.26rem;
  }
  .oik{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.26rem;
    color: #FF5836;
    text-align: center;
    font-style: normal;
  }
  .loan_total{
    padding: 0.13rem 0 0.06rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 0.01rem solid rgba(228,190,182,0.3);;
  }
  .ode{
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.06rem;
    color: #666666;
    text-align: left;
    font-style: normal;
  }
  .odebg{
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.06rem;
    color: #5B403B;
    text-align: left;
    font-style: normal;
  }
  .nkl{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.06rem;
    color: #333333;
    text-align: left;
    font-style: normal;
  }
  .nklbg{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.06rem;
    color: #5B403B;
    text-align: left;
    font-style: normal;
  }
  .loi{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.13rem;
  }
  .loan_button{
    height: fit-content;
    padding: 0.13rem 0rem;
    border-radius: 0.06rem;
    background: #FF5836;
    box-shadow: 0rem 0.01rem 0.04rem 0rem rgba(255,88,54,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.13rem;
    cursor: pointer;
  }
  .nia{
    width: 0.17rem;
    height: 0.17rem;
    margin-right: 0.04rem;
  }
  .cfq{
    color: rgba(255, 255, 255, 1);
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.13rem;
  }
  .loan_note{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.06rem;
    color: #999999;
    text-align: center;
    font-style: normal;
  }

  .support_panel {
    position: relative;
    min-height: 0.82rem;
    background: rgba(255,88,54,0.2);
    border-radius: 0.16rem;
    padding: 0.17rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 0.13rem;
  }
  .support_title {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.1rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.02rem;
  }
  .support_text {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.07rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.08rem;
  }

  .njc{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .koz{
    width: 0.09rem;
    height: 0.09rem;
    margin-right: 0.04rem;
  }
  .support_phone {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.08rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    position: relative;
    z-index: 1;
  }
  .support_image {
    width: 0.58rem;
    height: 0.58rem;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  @media screen and (max-width: 768px) {
    .loan_card {
      width: 100%;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loancard.vue